import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/auth";
import { getNavItems } from "@/components/layout/navConfig";

export const BottomNav = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { bottom } = getNavItems(user?.role);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur-md lg:hidden">
      <div className="safe-bottom mx-auto grid max-w-xl grid-cols-5 items-center px-1.5 pt-1">
        {bottom.map((item) => {
          if (item.fab) {
            return (
              <div key="fab" className="flex justify-center">
                <NavLink
                  to={item.to}
                  aria-label={item.label}
                  className="-mt-6 flex h-14 w-14 flex-col items-center justify-center rounded-2xl bg-brand text-brand-foreground shadow-elevated ring-4 ring-background transition-transform active:scale-95"
                >
                  <Plus className="h-6 w-6" strokeWidth={2.5} />
                </NavLink>
              </div>
            );
          }
          const Icon = item.icon;
          const active = item.end ? pathname === item.to : pathname.startsWith(item.to);
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={cn(
                "flex flex-col items-center gap-0.5 rounded-lg px-1 py-1.5 text-[10px] font-medium transition-colors",
                active ? "text-brand" : "text-muted-foreground"
              )}
            >
              <Icon className={cn("h-5 w-5", active && "stroke-[2.4]")} />
              <span className="truncate">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
